import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, TextField, } from '@doxyme/ui';
import { locationsData } from '../../selectors';
import operations from '../../../../../../dialogs/operations';
import './locations-dialog.scss';
import { captionIds } from './constants/caption-ids';
import actions from '../../actions';
const MAX_LENGTH = 30;
export const LocationsDialog = ({ id: locationId, name, onSubmit }) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const { header, body, footer } = captionIds;
    const isEditMode = Boolean(locationId);
    const headerCaption = isEditMode ? header.edit : header.create;
    const submitCaption = isEditMode ? footer.edit : footer.create;
    const [isDisabled, setIsDisabled] = useState(true);
    const locations = useSelector(locationsData);
    const form = useForm({
        mode: 'onChange',
        defaultValues: {
            name,
        },
    });
    const isLocationExist = useCallback((value) => {
        return locations.find((item) => (item.name).toLowerCase() === value.toLowerCase().trim());
    }, [locations]);
    const { errors } = form.formState;
    const validationRules = {
        required: intl.formatMessage(body.form.validation.required),
        maxLength: {
            value: MAX_LENGTH,
            message: intl.formatMessage(body.form.validation.maxLength, {
                number: MAX_LENGTH + 1,
            }),
        },
        validate: (value) => {
            if (isLocationExist(value)) {
                setIsDisabled(true);
                return intl.formatMessage(body.form.validation.locationExist);
            }
            setIsDisabled(false);
            return null;
        }
    };
    const onClose = useCallback(() => {
        operations.hide();
    }, []);
    const handleSubmit = (data) => {
        const editionData = { ...data, locationId };
        const action = isEditMode
            ? actions.editLocation(editionData)
            : actions.addLocation({ ...data, onSubmit });
        dispatch(action);
        onClose();
    };
    return (<Modal closeModal={onClose} isOpen isSmall closeOnOutsideClick>
      <form onSubmit={(e) => {
            e.preventDefault();
            void form.handleSubmit(handleSubmit)(e);
        }}>
        <ModalHeader onClose={onClose}>
          <h4>{intl.formatMessage(headerCaption)}</h4>
        </ModalHeader>

        <ModalBody complex>
          <TextField type="text" label={intl.formatMessage(body.form.label)} name="name" hasError={Boolean(errors.name)} errorText={errors.name?.message} ref={form.register(validationRules)}/>
        </ModalBody>

        <ModalFooter className="locations-dialog-footer">
          <Button btnStyle="outline" size="medium" onClick={onClose}>
            {intl.formatMessage(footer.cancel)}
          </Button>

          <Button type="submit" size="medium" disabled={isDisabled}>
            {intl.formatMessage(submitCaption)}
          </Button>
        </ModalFooter>
      </form>
    </Modal>);
};
